import CookieNotificationMessage from '../Scripts/NoneReactComponents/cookieNotificationMessage';
import Dealers from '../Scripts/NoneReactComponents/dealers';
import Favorites from '../Scripts/NoneReactComponents/favorites';
import SearchPage from '../Scripts/NoneReactComponents/searchpage';
import MobileNavigation from '../Scripts/NoneReactComponents/mobileNavigation';
import $ from 'jquery';
import Cookies from 'js-cookie';
import SlickSlider from 'slick-carousel';
import BootstrapOverrides from './NoneReactComponents/bootstrapOverrides';
import ProductPage from './NoneReactComponents/productPage';
//var mixitup = require('mixitup');
var mixitupMultifilter = require('./NoneReactComponents/mixitup.min');
var mixitupMultifilter = require('./NoneReactComponents/mixitup-multifilter.min');
var mixitupPagination = require('./NoneReactComponents/mixitup-pagination.min');
mixitup.use(mixitupPagination, mixitupMultifilter);

window.toggleMobileModal = function toggleMobileModal(modalId) {
    const desktopSize = 991;

    if (window.innerWidth > desktopSize) {
        return;
    }

    var modal = document.getElementById(modalId);

    modal.classList.toggle('mobile-modal__container--open');
    const isOpen = modal.classList.contains('mobile-modal__container--open');

    if(isOpen){
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
    }
    else {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
    }
}

window.initializeMobileModals = function () {
    document.querySelectorAll('[data-mobile-modal]').forEach(item => {

        if (item.getAttribute('mobile-modal-listener') !== 'true') {
            item.setAttribute('mobile-modal-listener', 'true');

            item.addEventListener('click', function (e) {
                toggleMobileModal(item.getAttribute('data-mobile-modal'));
            });
        }
    });
}

window.addEventListener('DOMContentLoaded', (event) => {

    if (document.querySelector('.cookieNotification') !== null) {
        new CookieNotificationMessage();
    }

    if (document.querySelector('.dealer-container') !== null) {
        new Dealers();
    }

    if (document.querySelector('#favorites') !== null) {
        new Favorites();
    }

    if (document.querySelector('#information') !== null) {
        new BootstrapOverrides();
    }

    if (document.querySelector('body#Product') !== null) {
        new ProductPage();
    }

    if (document.querySelector('.hit-count') !== null) {
        new SearchPage();
    }

    if (document.querySelector('.blog-slick-slider') !== null) {

        $(document).ready(function () {
            $('.blog-slick-slider').slick({
                slidesToShow: 1.2,
                slidesToScroll: 1,
                prevArrow: $('.blog-slick-prev'),
                nextArrow: $('.blog-slick-next'),
                dots: true,
                mobileFirst: true,
                infinite: false,
                customPaging: function (slick, index) {
                    return '';
                },
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4.5,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.2,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    },
                ]
            });
        });
    }

    if (document.querySelector(".news-filter") !== null) {
        var filter = document.querySelector(".news-filter");
        var mixer = mixitup(filter, {
            multifilter: {
                enable: true
            },
            pagination: {
                limit: filter.getAttribute("data-limit"),
                hidePageListIfSinglePage: true
            },
            templates: {
                pagerPrev: '<button type="button" class="mixitup-control prev" data-page="prev"><img src="/ui/images/arrow-left.svg" alt=""></button>',
                pagerNext: '<button type="button" class="mixitup-control next" data-page="next"><img src="/ui/images/arrow-right.svg" alt=""></button>'
            }

        });
    }

    // Show if any favorite is chosen
    var cookie = Cookies.get('favorites.variantids')
    // var headerHeart = document.querySelector(".navbar .bi-heart");
    //
    // if (cookie === undefined || cookie == null || cookie == "undefined") {
    //     headerHeart.classList.remove("bi-heart-fill", "text-primary");
    //     headerHeart.classList.add("bi-heart", "text-primary");
    // } else {
    //     headerHeart.classList.remove("bi-heart", "text-primary");
    //     headerHeart.classList.add("bi-heart-fill", "text-primary");
    // }

    new MobileNavigation();

    window.initializeMobileModals();

    document.querySelectorAll('.faceted-search__sublist.collapse').forEach(item => {
        const checked = item.querySelector('.faceted-filter__input').checked;

        item.parentNode.querySelector('.faceted-search__accordion-button').setAttribute("aria-expanded", true);

        if (checked) {
            item.classList.add("show");
        }

        document.querySelectorAll('[data-mobile-modal]').forEach(item => {
            item.addEventListener('click', function (element) {
                toggleMobileModal(item.getAttribute('data-mobile-modal'));
            });
        });
    });
});
    


